// TGS sticker files for AnimatedSticker component
import { TGS_STICKERS } from '~/constants/tgs-stickers';

export const Step1MainSticker = TGS_STICKERS.BEAR;
export const Step2MainSticker = TGS_STICKERS.DOODLES_HOLO_8;
export const Step3MainSticker = TGS_STICKERS.TEDDIE_STICKER_02;
export const Step4MainSticker = TGS_STICKERS.FINAL_ONBOARDING;

export const VomitSticker = TGS_STICKERS.VOMIT;
